const React = require("react");
const T = React.PropTypes;

require("./CompletedReportGrid.less");

const CompletionCount = require("~/types/CompletionCount.js").PropType;
const Error = require("~/types/Error.js").PropType;
const auditTypes = require("~/config.js").AuditTypes;
const reportDispatchers = require("~/events/reports/reportDispatchers.js"); 
const CompleteReportType = require("~/types/CompleteReport.js").PropType;
const DistrictReportType = require("~/types/DistrictReport.js").PropType; 

const ReportPane = require("../ReportPane/ReportPane.jsx");
const ToolTip = require("../../ToolTip/ToolTip.jsx"); 

const MajorMessage = require("../../MajorMessage/MajorMessage.jsx");
const MajorError = require("../../MajorError/MajorError.jsx");
const MajorLoading = require("../../MajorLoading/MajorLoading.jsx");

const CompletedReportGrid = React.createClass({
    propTypes: { 
        SelectedDivisionNumber: T.string,
        SelectedAuditType: T.string,
        SelectedAuditPeriod: T.string,
        CompleteReport: CompleteReportType.isRequired,
        DistrictReport: DistrictReportType.isRequired,
        DateRange: T.string.isRequired
    },
    getInitialState() {
        return {
            ShowOverlay: false,
            SelectedDistrict: 0
        }
    },
    GetSecondGridDataRow() {
        const tableOptionsDistricts = this.props.CompleteReport.Districts
            .map((d) => {
                return (<td key={d} className="cs-ReportGrid__main__table-data">{d}</td>); 
            });

        return (<tr className="cs-ReportGrid__main__table-row">
                    {this.tableOptionsDistricts}
                    {this.tableOptionsDistricts}
                    {this.tableOptionsDistricts}
                    {this.tableOptionsDistricts}
                    </tr>); 
    },
    CalculatePercent(dividend, divisor) { 
        let percent = 0;

        if (dividend > 0 && divisor > 0) {
            percent = (dividend / divisor) * 100
        }

        return Math.floor(percent); 
    }, 
    TotalStoreCount() {
        var result = 0; 
        for (var i = 0; i < this.props.CompleteReport.StoreCount.length; i++)
        {
            result += this.props.CompleteReport.StoreCount[i]; 
        }
        return result; 
    },
    TotalAuditCount() { 
        var result = 0;
        for (var i = 0; i < this.props.CompleteReport.AuditCount.length; i++) 
        {
            result += this.props.CompleteReport.AuditCount[i]; 
        }
        return result; 
    },
    TotalNinetyDayCount() { 
        var result = 0;
        for (var i = 0; i < this.props.CompleteReport.NinetyDayCount.length; i++)
        {
            result += this.props.CompleteReport.NinetyDayCount[i]; 
        }
        return result; 
    },
    ClickTableRow: function (district) {

        let division = this.props.CompleteReport.Division;
        let auditType = this.props.SelectedAuditType;
        let dateRange = this.props.DateRange.replace(" ", "-");

        reportDispatchers.GetDistrictReport(division, district, auditType, dateRange); 

        let state = {
            ShowOverlay: true,
            SelectedDistrict: district
        }; 
        this.setState(state);
    },
    onCloseOverlay: function() { 
        let state = {
            ShowOverlay: false,
            SelectedDistrict: 0
        };
        this.setState(state); 
    }, 
    GetSecondTable(totalStoreCount, totalAuditCount, totalPercent, totalNinetyDayCount) {

        let rows = [];
        for (var i = 0; i < this.props.CompleteReport.Districts.length; i++)
        {
            let percent = this.CalculatePercent(this.props.CompleteReport.AuditCount[i], this.props.CompleteReport.NinetyDayCount[i]); 

            let cells = [
                (<td key={i}>{this.props.CompleteReport.Districts[i]}</td>), 
                (<td key={-i - 1 }>{this.props.CompleteReport.StoreCount[i]}</td>), 
                (<td key={i + 1000}>{this.props.CompleteReport.NinetyDayCount[i]}</td>),
                (<td key={i + 100}>{this.props.CompleteReport.AuditCount[i]}</td>), 
                (<td key={-i - 101}>{percent}%</td>)
            ];

            const row = (<tr key={i + 2000} onClick={this.ClickTableRow.bind(this, this.props.CompleteReport.Districts[i])} className="cs-ReportGrid__main__table-row">
                {cells}
                </tr>); 

            rows.push(row); 
        }

        const result = (<div className="cs-NewTable"><table className="table-fill">
                        <tbody className="table-hover">
                            <tr>
                                <th className="text-left">District</th>
                                <th className="text-left">Total Store Count</th>
                                <th className="text-left">Stores &gt; 90 Days</th>
                                <th className="text-left">Audit Count</th>
                                <th className="text-left">% Complete</th>
                            </tr>
                            {rows}
                            <tr>
                                <td className="text-left">Total</td>
                                <td className="text-left">{totalStoreCount}</td>
                                <td className="text-left">{totalNinetyDayCount}</td>
                                <td className="text-left">{totalAuditCount}</td>
                                <td className="text-left">{totalPercent}%</td>
                            </tr>
                        </tbody>
                </table></div>); 

        return result; 
    }, 
    render () {

        const totalStoreCount = this.TotalStoreCount();

        const totalNinetyDayCount = this.TotalNinetyDayCount(); 

        const totalAuditCount = this.TotalAuditCount(); 

        const secondGridDataRow = this.GetSecondGridDataRow();

        const totalPercent = this.CalculatePercent(totalAuditCount, totalNinetyDayCount); 

        const secondTable = this.GetSecondTable(totalStoreCount, totalAuditCount, totalPercent, totalNinetyDayCount);

        const tooltiptotal = (<ToolTip Message={"The total store count for the Division" }></ToolTip>); 
        const tooltipaudit = (<ToolTip Message={"Number of stores over 90 days old. Stores that are older than 90 days are within the eligable auditing period." }></ToolTip>); 
        const tooltipauditcount = (<ToolTip Message={"The number of audits for stores that are greater than 90 days old" }></ToolTip>)
        const tooltippercentage = (<ToolTip Message={"The percentage of audits complete for stores that are greater than 90 days old." }></ToolTip>); 

        return (<section className="cs-ReportGrid__section">
                <h2 className="cs-ReportGrid__header">Completed Audits</h2>
    <section className="cs-ReportGrid__preview__table-section">
            <div className="cs-NewTable">
                <table className="table-fill">
                    <tbody className="table-hover">
                    <tr>
                        <th className="text-left">Division</th>
                        <th className="text-left">
                            Total Store Count
                            {tooltiptotal}
                        </th>
                        <th className="text-left">
                            Stores &gt; 90 Days
                            {tooltipaudit}
                        </th>
                        <th className="text-left">
                            Audit Count
                            {tooltipauditcount}
                        </th>
                        <th className="text-left">
                            % Completed
                            {tooltippercentage}
                        </th>
                    </tr>
                    <tr>
                        <td className="text-left">{this.props.CompleteReport.Division}</td>
                        <td className="text-left">{totalStoreCount}</td>
                        <td className="text-left">{totalNinetyDayCount}</td>
                        <td className="text-left">{totalAuditCount}</td>
                        <td className="text-left">{totalPercent}%</td>
                    </tr>
                    </tbody>
                </table>
    </div>
    </section>
    <section className="cs-ReportGrid__main__table-section">
        {secondTable}
    </section>
            {this.state.ShowOverlay && (<ReportPane onClose={this.onCloseOverlay}
                                                    District={this.state.SelectedDistrict}
                                                    DistrictReport={this.props.DistrictReport}
                                                    AuditType={this.props.CompleteReport.AuditTypeName}>
                                                    </ReportPane>)}
            
            </section>


            );
    }

});

module.exports = CompletedReportGrid; 


// WEBPACK FOOTER //
// ./src/components/Reports/CompletedReportGrid/CompletedReportGrid.jsx